var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-auto mt-6",staticStyle:{"max-width":"400px"}},[_c('v-btn',{staticClass:"primary--text mx-auto",attrs:{"color":"#212121","dark":"","to":"/","block":""}},[_vm._v(" לעוד תפילות לחצו כאן ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }